import React from 'react';
import cx from 'classnames';
import './css/ProgressBar.scss';
import Bar from '@setproduct-ui/core/ProgressBar';

type Props = {
  position?: number;
  total?: number;
  title?: string;
  refill?: boolean;
  className?: string;
};

const ProgressBar = ({ position, total, title = 'Clinical Intake', refill = false, className = '' }: Props) => {
  let percentage = 0;
  if (position && total) {
    percentage = ((position - 1) / total) * 0.99; // We don't need to show 100% (#183024343)
  }

  return (
    <div className={cx('progress-bar', className)}>
      <div className="flex">
        <h6>
          <div className="line-bar" />
          {title}
        </h6>
        {!!percentage && (
          <div className="bar">
            <Bar animate={false} stripes={false} value={percentage} />
            <span>{(percentage * 100).toFixed(0)}%</span>
          </div>
        )}
      </div>
      {refill && (
        <div className="mx-4 mt-6">
          <p className="gold mb-3">MEDICAL QUESTIONS</p>
          So our licensed clinicians are accurately tracking the progress of your treatment, please complete the
          following questions:
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
